import React from 'react';
import { 
  FiInstagram, FiTwitter, FiYoutube, FiLinkedin, 
  FiFacebook, FiGlobe, FiMessageSquare, FiMessageCircle,
  FiMail,  FiMusic, FiFilm, FiRss,
  FiGithub, FiGitlab, FiSlack, FiTrello,
 FiTwitch, FiPocket
} from 'react-icons/fi';
import { FaReddit, FaSnapchat, FaPinterestP, FaTiktok, FaWhatsapp } from 'react-icons/fa';

const socialApps = [
  { name: 'Instagram', icon: <FiInstagram />, url: 'https://instagram.com' },
  { name: 'Twitter', icon: <FiTwitter />, url: 'https://twitter.com' },
  { name: 'YouTube', icon: <FiYoutube />, url: 'https://youtube.com' },
  { name: 'LinkedIn', icon: <FiLinkedin />, url: 'https://linkedin.com' },
  { name: 'Facebook', icon: <FiFacebook />, url: 'https://facebook.com' },
  { name: 'Google', icon: <FiGlobe />, url: 'https://google.com' },
  { name: 'Snapchat', icon: <FaSnapchat />, url: 'https://snapchat.com' },
  { name: 'Pinterest', icon: <FaPinterestP />, url: 'https://pinterest.com' },
  { name: 'TikTok', icon: <FaTiktok />, url: 'https://tiktok.com' },
  { name: 'WhatsApp', icon: <FaWhatsapp />, url: 'https://web.whatsapp.com' },
  { name: 'Reddit', icon: <FaReddit />, url: 'https://reddit.com' },
  { name: 'Twitch', icon: <FiTwitch />, url: 'https://twitch.tv' },
  { name: 'Discord', icon: <FiMessageSquare />, url: 'https://discord.com' },
  { name: 'Slack', icon: <FiSlack />, url: 'https://slack.com' },
  { name: 'Trello', icon: <FiTrello />, url: 'https://trello.com' },
  { name: 'GitHub', icon: <FiGithub />, url: 'https://github.com' },
  { name: 'GitLab', icon: <FiGitlab />, url: 'https://gitlab.com' },
  { name: 'Messenger', icon: <FiMessageCircle />, url: 'https://messenger.com' },
  { name: 'Gmail', icon: <FiMail />, url: 'https://mail.google.com' },
  { name: 'Spotify', icon: <FiMusic />, url: 'https://spotify.com' },
  { name: 'Netflix', icon: <FiFilm />, url: 'https://netflix.com' },
  { name: 'Pocket', icon: <FiPocket />, url: 'https://getpocket.com' },
  { name: 'RSS', icon: <FiRss />, url: 'https://rss.com' }
];

function SocialMediaDropdown() {
  return (
    <div className="social-dropdown-page">
      <h2> FAKE CONTENT RENDER </h2>
      <p className="social-subtitle"> </p>
      <div className="social-apps-grid">
        {socialApps.map((app, index) => (
          <a 
            key={index} 
            href={app.url} 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-app-card"
            aria-label={`Visit our ${app.name}`}
          >
            <div className="social-app-icon">{app.icon}</div>
            <span>{app.name}</span>
          </a>
        ))}
      </div>
    </div>
  );
}

export default SocialMediaDropdown;